import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qualification',
  templateUrl: './qualification.component.html',
  styleUrls: ['./qualification.component.scss']
})
export class QualificationComponent implements OnInit {

  constructor() { }
  education: Boolean = true;
  work: Boolean = false;

  ngOnInit(): void {
  }

  onClickEducation() {
    this.education = true;
    this.work = false;
  }

  onClickWork() {
    this.education = false;
    this.work = true;
  }

}
